module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-5 pb-5"
  }, [_c('div', {
    staticClass: "mb-4",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('@/assets/img/search.svg'),
      "height": "100",
      "width": "100"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n            Anda masih memiliki proses yang belum diselesaikan, ingin\n            melanjutkan?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-7"
  }, [_c('v-row', {
    staticClass: "d-flex align-center d-flex"
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "color": "blew",
      "dark": "",
      "depressed": "",
      "block": "",
      "height": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("\n                        Ya\n                    ")])], 1), _vm._v(" "), _c('v-col', [_c('v-btn', {
    staticStyle: {
      "border": "1.6px solid"
    },
    attrs: {
      "color": "blew",
      "outlined": "",
      "depressed": "",
      "block": "",
      "height": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n                        Tidak\n                    ")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20ebdfc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class/components/DialogConfirmSessionUpload.vue
// module id = 1688
// module chunks = 1